import { render } from "./FilterSelect.vue?vue&type=template&id=0877aab8&ts=true"
import script from "./FilterSelect.vue?vue&type=script&lang=ts"
export * from "./FilterSelect.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__